import { ScheduleActionContent } from '../types';

export function getContentLabel(content: ScheduleActionContent) {
  const candidate = content.title ?? content.name ?? content.label;
  return typeof candidate === 'string' && candidate.trim() ? candidate : content.id;
}
